import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorResponseComponent } from './pages/error-response/error-response.component';
import { PageNotfoundComponent } from './pages/page-notfound/page-notfound.component';
import { PaymentFormAmexComponent } from './pages/payment-form-amex/payment-form-amex.component';
import { PaymentFormComponent } from './pages/payment-form/payment-form.component';
import { SuccessResponseComponent } from './pages/success-response/success-response.component';
import { OpenpayComponent } from './pages/openpay/openpay.component';
import { OpenpayRedirectComponent } from './pages/openpay-redirect/openpay-redirect.component';

const appRoutes: Routes = [
  {
    path: '',
    component: PageNotfoundComponent,
  },
  {
    path: '3dsecure',
    component: PaymentFormComponent,
  },
  {
    path: 'openpay',
    component: OpenpayComponent,
  },
  {
    path: 'redirect',
    component: OpenpayRedirectComponent,
  },
  {
    path: '3dsecure/amex',
    component: PaymentFormAmexComponent,
  },
  {
    path: 'error',
    component: ErrorResponseComponent,
  },
  {
    path: 'success',
    component: SuccessResponseComponent,
  },
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '**', component: PageNotfoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false, // <-- debugging purposes only
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/
